import { render, staticRenderFns } from "./OfflineMessageForm.vue?vue&type=template&id=2db0814c&scoped=true"
import script from "./OfflineMessageForm.vue?vue&type=script&lang=js"
export * from "./OfflineMessageForm.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OfflineMessageForm.vue?vue&type=style&index=0&id=2db0814c&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2db0814c",
  null
  ,true
)

export default component.exports